module.exports = __webpack_public_path__ + "static/media/MMAFinancial.71a13afa.gif";